import React from "react"
import { view } from "react-easy-state"
import { isMobile } from "react-device-detect"
import { Select, Input, Row, Col, message } from "antd"

import Header from "components/common/layouts/Header"
import Footer from "components/common/layouts/Footer"
import ContentLoader from "components/common/ContentLoader"
import ContentLoadingFailed from "components/common/ContentLoadingFailed"
import ChapterList from "components/pages/students/chapters/index/ChapterList"

import globalStore from "store"

import ChaptersService from "services/students/chapters.service"

const topbarFilterLeftColSpan = {
  xs: { span: 24 },
  sm: { span: 16 },
  md: { span: 18 },
}

const topbarFilterRightColSpan = {
  xs: { span: 24 },
  sm: { span: 8 },
  md: { span: 6 },
}

class ChaptersIndexPage extends React.Component {
  async componentDidMount() {
    const { subjectId } = this.props.match.params

    const pageState = globalStore.ui.students.chapters.index
    await ChaptersService.index({ pageState, subjectId })
  }

  renderPageContent() {
    const pageState = globalStore.ui.students.chapters.index
    const { chapters, subject, chapterErrors, subjectErrors, API_CHAPTERS_INDEX_STATUS } = pageState

    if (!API_CHAPTERS_INDEX_STATUS) return <ContentLoader />
    if (API_CHAPTERS_INDEX_STATUS === "pending") return <ContentLoader />
    if (API_CHAPTERS_INDEX_STATUS === "rejected") return <ContentLoadingFailed />

    if (subjectErrors) {
      message.destroy()
      message.error(subjectErrors)
      this.props.history.replace("/courses")
      return
    }

    if (chapterErrors) {
      const { course } = subject.relationships

      message.destroy()
      message.error(chapterErrors)
      this.props.history.replace(`/courses/${course.data.id}/subjects`)
      return
    }

    return <ChapterList chapters={chapters} />
  }

  goBackToSubjects = () => {
    const { subject } = globalStore.ui.students.chapters.index

    const backUrl =
      subject && subject.relationships.course && subject.relationships.course.data
        ? `/courses/${subject.relationships.course.data.id}/subjects`
        : `/courses`

    this.props.history.push(backUrl)
  }

  componentWillUnmount() {
    globalStore.ui.students.chapters.index = {}
  }

  render() {
    const filterRow = (
      <div className="topbar-filter">
        <Row>
          <Col {...topbarFilterLeftColSpan} className="m-t-20">
            <div className="left-items">
              <div>
                <span>Category: </span>
                <Select defaultValue="all">
                  <Select.Option value="all">All</Select.Option>
                </Select>
              </div>
              <div>
                <span>Author: </span>
                <Select defaultValue="all">
                  <Select.Option value="all">All</Select.Option>
                </Select>
              </div>
            </div>
          </Col>
          <Col {...topbarFilterRightColSpan} className="m-t-20">
            <Input type="search" placeholder="Find a chapter" />
          </Col>
        </Row>
      </div>
    )

    return (
      <div className={`page course-page ${isMobile ? "mobile" : ""}`}>
        <Header />
        <div className="page-content">
          {false && filterRow}
          {this.renderPageContent()}
        </div>
        <Footer />
      </div>
    )
  }
}

export default view(ChaptersIndexPage)
